export default __webpack_public_path__ + "static/B0236-af841f8e7286725f84b0cde007da8abe.png";